import { render, staticRenderFns } from "./DlvES.vue?vue&type=template&id=f5a685a4"
import script from "./DlvES.vue?vue&type=script&lang=js"
export * from "./DlvES.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports